import { Component, Inject, ViewChild, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CropperComponent } from 'angular-cropperjs';
import {
  DEFAULT_CROPPER_CONFIG,
  WIDE_SIZE_CROPPER_CONFIG
} from '@tripointe/tripointe-cms/constants';

@Component({
  selector: 'tp-image-cropper-dialog',
  templateUrl: './image-cropper-dialog.component.html',
  styleUrls: ['./image-cropper-dialog.component.scss']
})
export class ImageCropperDialogComponent {
  @ViewChild('angularCropper', { static: false }) angularCropper: CropperComponent;

  config;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string; wideSizeCropper?: boolean },
    private dialogRef: MatDialogRef<any>,
    private ngZone: NgZone
  ) {
    this.config = data?.wideSizeCropper ? WIDE_SIZE_CROPPER_CONFIG : DEFAULT_CROPPER_CONFIG;
  }

  save(): void {
    this.angularCropper.cropper.getCroppedCanvas().toBlob((blob: Blob) => {
      // without zone angular doesn't see close event immediately(https://github.com/angular/components/issues/7550)
      this.ngZone.run(() => {
        this.dialogRef.close(blob);
      });
    }, 'image/jpeg');
  }
}
